import { ENVIRONMENT } from '@consts/env';

export function isProduction(): boolean {
  return ENVIRONMENT === 'production';
}
